import { render } from "./Manage.vue?vue&type=template&id=9981c63c&scoped=true&lang=pug"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=9981c63c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9981c63c"]])

export default __exports__